import { render, staticRenderFns } from "./ModalLeaveQuestion.vue?vue&type=template&id=0d57371a&scoped=true&lang=pug&"
import script from "./ModalLeaveQuestion.vue?vue&type=script&lang=ts&"
export * from "./ModalLeaveQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./ModalLeaveQuestion.vue?vue&type=style&index=0&id=0d57371a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d57371a",
  null
  
)

export default component.exports